export type TrackEvent =
  | 'iframePageview'
  | 'iframeFinal'
  | 'best-offer'
  | 'wsContactDataProcessingConsentCheck'

export type TransactionEvent = 'iframeLead'

interface TransactionProduct {
  sku: string
  name: string
  price: number
  category: string
  quantity: '1'
}

export interface Transaction {
  event: TransactionEvent
  traversalId?: string
  affiliate?: string
  personId?: string
  transactionId: string
  transactionTotal: number
  transactionProducts: TransactionProduct[]
}

export interface TrackEventData {
  event: TrackEvent
  step?: string
  conf?: string
  affiliate?: string
  personId?: string
  leadid?: string
  traversalId?: string
  revenue?: number
  name?: number
  purpose?: string
}

export interface TrackBestOfferData extends TrackEventData {
  event: 'best-offer'
  offer: Record<string, unknown>
}
export interface TransactionTeal {
  label?: string
  event: string
  // eslint-disable-next-line camelcase
  order_id?: string
  total?: number
  products?: [
    {
      sku: string
      category: string
      quantity: number
      price: number
    }
  ]
  traversalId?: string
  leadIdHash?: string
  amount?: string | number
  purpose?: string
  category?: string
  term?: string | number
  currency?: string
  optimizely?: Record<string, string> | unknown
  step?: string
}

export enum AbTestsType {
  SITESPECT = 'SITESPECT',
  OPTIMIZELY = 'OPTIMIZELY'
}
